<template>
    <div id="loading">
        <img class="img" src="../../assets/2796ed81999693.5d10c0872415e.gif" alt="loading..." width="250" />
    </div>
</template>
  
<script>
export default {
    name: "Loading"
};
</script>
<style>
#loading {
    position: fixed;
    z-index: 1000;
    background-color: white;
    height: 100%;
    width: 100%;
    opacity: 0.6;
    text-align: center;
    line-height: auto;
}

.img {
    position: relative;
    margin: auto;
    margin-top: 15%;
}
</style>